import { useEffect, useState } from 'react';

const MIN_KEYWORD_LENGTH = 3;

const useSearchDebouncedPromise = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    let handler;

    if (value.length >= MIN_KEYWORD_LENGTH) {
      handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
    } else if (value.length === 0) {
      setDebouncedValue(value);
    }

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useSearchDebouncedPromise;
